import { _internalApiGetRenderId } from "./Runtime.js";
export async function startSSEStream(task, _ref) {
  let {
    progress,
    success,
    error,
    finally: finallyCallback
  } = _ref;
  const currentRenderId = _internalApiGetRenderId();
  try {
    const stream = await task();
    for await (const value of stream) {
      if (currentRenderId !== _internalApiGetRenderId()) {
        return;
      }
      progress === null || progress === void 0 || progress(value);
    }
    if (currentRenderId !== _internalApiGetRenderId()) {
      return;
    }
    success === null || success === void 0 || success();
  } catch (e) {
    if (currentRenderId !== _internalApiGetRenderId()) {
      return;
    }
    error === null || error === void 0 || error(e);
  } finally {
    finallyCallback === null || finallyCallback === void 0 || finallyCallback();
  }
}
//# sourceMappingURL=sse.js.map